function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#4D4D4D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 41.3v12c0 1.1.9 2 2 2h40c1.1 0 2-.9 2-2v-12H10z",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.6 19.4c3.8 7.3 7.6 14.7 11.4 22H10c3.8-7.3 7.6-14.7 11.4-22",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 8.7v19.5M32 8.7l3.7 3.7M28 12.4l3.7-3.7"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 47.3,
  cy: 46.7,
  r: 2.3
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M21.4 19.4h6.1M36.4 19.4h6.1M21.9 36.4h20M23.5 32.1h16.7"
}));
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    width: 64
  }, props), _ref);
};
export default SvgUploadIcon;